// App.js
import React, { useEffect, useContext, useState } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import RegistrationForm from './components/RegistrationForm';
import LoginForm from './components/LoginForm';
import WelcomeScreen from './components/WelcomeScreen.js';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import GameComponent from './components/GameComponent.js';
import BlotPage from './components/BlotPage';
import Deposit from './components/Deposit';
import DepositStarsPage from './components/DepositStarsPage';
import WithdrawStarsPage from './components/WithdrawStarsPage';
import Withdraw from './components/Withdraw';
import TransactionHistory from './components/TransactionHistory';
import DepositWithdrawAllPage from './components/DepositWithdrawAllPage';
import Profile from './components/Profile';
import FriendsPage from './components/Friends';
import Tasks from './components/Tasks';
import More from './components/More';
import PlayedGameHistory from './components/PlayedGameHistory';
import AffiliateProgram from './components/AffiliateProgram';
import ScoreHistory from './components/ScoreHistory'; 
import { AuthContext } from './context/AuthContext';
import { apiRequest } from './api';
import './App.css'; 
import API_BASE_URL from './apiConfig';
import LoadingScreen from './components/LoadingScreen';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import CompletedGamesPage from './components/CompletedGamesPage';
import UsersPage from './components/UsersPage';
import RPSGame from './components/RPSGame';
import PokerGame from './components/PokerGame';
import DominoGame from './components/DominoGame';
import CarromGame from './components/CarromGame';
import BackgammonGame from './components/BackgammonGame';
import TokenToUsdtPage from './components/TokenToUsdtPage';
import audioManager from './components/AudioManager';
import { homeAssets } from './components/assetImports';
import { useTranslation } from 'react-i18next';
import './i18n/config';
import i18n from './i18n/config';


const App = () => {
    const { t } = useTranslation('app');
    const { user, wallets, setWallets,isGameLoading } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();
    const [pageTransition, setPageTransition] = useState(false);
    const [isGeneratingLink, setIsGeneratingLink] = useState(false); 
    const [inviteLink, setInviteLink] = useState('');
    const [showCopyPopup, setShowCopyPopup] = useState(false);
    const [isFooterVisible, setIsFooterVisible] = useState(true);
    const [isTelegramMiniApp, setIsTelegramMiniApp] = useState(false);

    const savedReferrerId = localStorage.getItem('referralInviterId');

useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('referrerId');

    // ONLY store referral ID if user is NOT logged in
    if (ref && !user) {
        localStorage.setItem('referralInviterId', ref);
    }
}, [user, location.search]);


useEffect(() => {
  const namespaces = [
    'app',
    'affiliate',
    'friends',
    'game',
    'gameHistory',
    'games',
    'login',
    'more',
    'tasks',
    'transactionHistory',
    'profile',
    'depositWithdrawAll'
  ];

  i18n.loadNamespaces(namespaces, () => {
  });
  i18n.reloadResources();
}, []);


    useEffect(() => {
        const tg = window.Telegram?.WebApp;
    
        function setAppHeight() {
            if (!tg) {
                document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
            }
        }
    
        if (tg) {
            tg.ready();
            tg.enableClosingConfirmation();
            if(tg.initData){
           //     setIsTelegramMiniApp(true);
            }
            
            
    
            try {
                if(tg.initData){
                    tg.lockOrientation();
                }
                
            } catch (e) {
                console.warn("Orientation lock failed:", e);
            }
        } else {
            // Initial set
            setAppHeight();
            // Update on resize
            window.addEventListener('resize', setAppHeight);
        }
    
        const preventTouch = (e) => {
            if (e.touches.length > 1) e.preventDefault();
        };
    
       try {
        document.addEventListener('touchstart', preventTouch, { passive: false });
        document.addEventListener('touchmove', preventTouch, { passive: false });
        } catch (err) {
        console.warn('Touch event listener failed:', err);
        }
    
        return () => {
            document.removeEventListener('touchstart', preventTouch);
            document.removeEventListener('touchmove', preventTouch);
    
            if (!tg) {
                window.removeEventListener('resize', setAppHeight);
            }
    
            if (tg) {
                try {
                    
                    tg.unlockOrientation();
                } catch (e) {
                    console.warn("Orientation unlock failed:", e);
                }
            }
        };
    }, []);
    


    
    


    useEffect(() => {
        const scrollableContent = document.getElementById('scrollableContent');
       
        setIsFooterVisible(true);
   
        if (scrollableContent) {
            scrollableContent.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }

     
        
    }, [location.pathname]);
    

    useEffect(() => {

        const tg = window.Telegram?.WebApp;

        const backButtonRoutes = [
            '/deposit',
            '/withdraw',
            '/depositStars',
            '/withdrawStars',
            '/Token-To-Usdt',
            '/transaction-history',
            '/played-games-history',
            '/affiliate-program',
            '/profile',
            '/deposit-withdraw-All'
        ];

        if (tg) {
            if(tg.initData){
            if (backButtonRoutes.includes(location.pathname)) {
                window.Telegram.WebApp.BackButton.show();
                window.Telegram.WebApp.BackButton.onClick(() => {
                    navigate(-1); 
                });
            } else {
                window.Telegram.WebApp.BackButton.hide();
                window.Telegram.WebApp.onEvent('mainButtonClicked', () => {
                    window.Telegram.WebApp.close();
                });
            }
            }

            
        }
        // Clean up event listeners
        return () => {
            if(tg.initData){
            window.Telegram.WebApp.BackButton.offClick();
            }
           
        };
    }, [location, navigate]);


      
    useEffect(() => {
        if (user && location.pathname === '/login') {
            if (savedReferrerId) {
      navigate(`/game?referrerId=${savedReferrerId}`, { replace: true });
    } else {
      navigate('/game', { replace: true });
    }
            
        }
    }, [user, location, navigate]);

  
  


   

    useEffect(() => {
        if (user) {
            setInviteLink(''); 
            handleGetInviteLink(); 
        }
    }, [user]);

useEffect(() => {
    const fullUrl = window.location.href;

    if (location.pathname === '/game') {
        window.history.pushState(null, '', fullUrl);

        const handlePopState = () => {
            window.history.pushState(null, '', fullUrl);
            navigate('/game', { replace: true });
        };

        window.addEventListener('popstate', handlePopState);

        return () => window.removeEventListener('popstate', handlePopState);
    }
}, [location.pathname, navigate]);






   
         
        


    const handleNavigation = (path) => {
        setPageTransition(true); 
        setTimeout(() => {
            navigate(path); 
            setPageTransition(false);
        }, 200); 
    };

    const handleGetInviteLink = async () => {

          const telegramInviteLink =
                `https://t.me/TG_Game_stars_bot?start=${user._id}`;
                setInviteLink(telegramInviteLink);
    };

    const handleShareLink = async () => {
        
    

        const linkToShare =  user?.inviteLink || `https://t.me/TG_Game_stars_bot?start=${user?._id}`;
    

        const telegramShareLink = `https://t.me/share/url?url=${encodeURIComponent(linkToShare)}&text=${encodeURIComponent("💰 Join me and earn rewards! Let's play-to-earn together!")}`;
    

        window.open(telegramShareLink, '_blank');
    };

    const handleCopyLink = async () => {

        if (!inviteLink) {
            await handleGetInviteLink(); 
        }

        try {
            if (navigator.clipboard) {
                await navigator.clipboard.writeText(inviteLink);
            } else {
                const tempInput = document.createElement('input');
                tempInput.value = inviteLink;
                document.body.appendChild(tempInput);
                tempInput.select();
                document.execCommand('copy');
                document.body.removeChild(tempInput);
            }

            setShowCopyPopup(true);
        } catch (err) {
            console.error('Failed to copy the link:', err);
        }
    };

    const [carromRematchKey, setCarromRematchKey] = useState(0);
    const [backgammonRematchKey, setBackgammonRematchKey] = useState(0);
    const [blotRematchKey, setBlotRematchKey] = useState(0);
    const [rpsRematchKey, setRpsRematchKey] = useState(0);
    const [pokerRematchKey, setPokerRematchKey] = useState(0);
    const [dominoRematchKey, setDominoRematchKey] = useState(0);

    return (
        <div className="appPage">
            {isGameLoading && <LoadingScreen />}
            
            <div className={`page-container ${pageTransition ? 'page-exit' : ''}`}>
                <Routes>
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/welcome" element={<WelcomeScreen isTelegramMiniApp={isTelegramMiniApp} referrerId={savedReferrerId} />}  />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/completed-games" element={<CompletedGamesPage />} />
                <Route path="/admin/users" element={<UsersPage />} />
                    <Route path="/register" element={<RegistrationForm />} />
                    <Route path="/login" element={<LoginForm referrerId={savedReferrerId} />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />
                    <Route path="/game" 
                        element={
                            user ? (
                              <GameComponent 
                                wallets={wallets}
                                setWallets={setWallets}
                                isTelegramMiniApp={isTelegramMiniApp}  
                                setFooterVisible={setIsFooterVisible}
                                referrerId={savedReferrerId} 
             
                              />
                            ) : (
                              <LoginForm referrerId={savedReferrerId} />
                            )
                        }
                    />
                    <Route path="/deposit" 
                        element={
                            user ? 
                            <Deposit setFooterVisible={setIsFooterVisible} /> : 
                            <LoginForm />
                        } 
                    />
                    <Route path="/withdraw" element={user ? <Withdraw wallets={wallets} setWallets={setWallets} /> : <LoginForm />} />
                    <Route path="/transaction-history" element={user ? <TransactionHistory isTelegramMiniApp={isTelegramMiniApp}   /> : <LoginForm />} />
                    <Route path="/depositStars" element={user ? <DepositStarsPage wallets={wallets} setWallets={setWallets} /> : <LoginForm />} />
                    <Route path="/withdrawStars" element={user ? <WithdrawStarsPage  wallets={wallets} setWallets={setWallets} isTelegramMiniApp={isTelegramMiniApp} /> : <LoginForm />} />
                    <Route path="/deposit-withdraw-All" element={user ? <DepositWithdrawAllPage isTelegramMiniApp={isTelegramMiniApp}   /> : <LoginForm />} />
                    <Route path="/Token-To-Usdt" element={user ? <TokenToUsdtPage  wallets={wallets} setWallets={setWallets} isTelegramMiniApp={isTelegramMiniApp}/> : <LoginForm />} />
                    <Route path="/played-games-history" element={user ? <PlayedGameHistory isTelegramMiniApp={isTelegramMiniApp}  /> : <LoginForm />} />
                    <Route path="/affiliate-program" element={user ? <AffiliateProgram isTelegramMiniApp={isTelegramMiniApp} /> : <LoginForm />} />
                    <Route path="/profile" element={user ? <Profile wallets={wallets} setWallets={setWallets} isTelegramMiniApp={isTelegramMiniApp} /> : <LoginForm />} />
                    <Route path="/friends" element={user ? <FriendsPage wallets={wallets} setWallets={setWallets} isTelegramMiniApp={isTelegramMiniApp} /> : <LoginForm />} />
                    <Route path="/tasks" element={user ? <Tasks wallets={wallets} setWallets={setWallets} isTelegramMiniApp={isTelegramMiniApp} /> : <LoginForm />} />
                    <Route path="/more" element={user ? <More isTelegramMiniApp={isTelegramMiniApp} /> : <LoginForm />} />
                    <Route path="/score-history" element={user ? <ScoreHistory /> : <LoginForm />} />
                    <Route path="/" element={user ? <GameComponent wallets={wallets} setWallets={setWallets} isTelegramMiniApp={isTelegramMiniApp}  /> : <LoginForm />} />
                    <Route 
                        path="/rps" 
                        element={
                            user ? (
                                <RPSGame 
                                key={`carrom-${rpsRematchKey}`}
                                onRematch={() => setRpsRematchKey(k => k + 1)}
                                />
                                ) : (
                                <LoginForm />
                                )
                                }
                        />
                    <Route 
                        path="/blot" 
                        element={
                            user ? (
                                <BlotPage 
                                key={`blot-${blotRematchKey}`}
                                setWallets={setWallets}
                                onRematch={() => setBlotRematchKey(k => k + 1)}
                                />
                                ) : (
                                <LoginForm />
                                )
                                }
                        />
                    <Route 
                        path="/carrom" 
                        element={
                            user ? (
                                <CarromGame 
                                key={`carrom-${carromRematchKey}`}
                                onRematch={() => setCarromRematchKey(k => k + 1)}
                                />
                                ) : (
                                <LoginForm />
                                )
                                }
                        />
                    <Route 
                        path="/backgammon" 
                        element={
                            user ? (
                                <BackgammonGame 
                                key={`carrom-${backgammonRematchKey}`}
                                onRematch={() => setBackgammonRematchKey(k => k + 1)}
                                />
                                ) : (
                                <LoginForm />
                                )
                                }
                        />
                        <Route 
                        path="/poker" 
                        element={
                            user ? (
                                <PokerGame 
                                key={`carrom-${pokerRematchKey}`}
                                onRematch={() => setPokerRematchKey(k => k + 1)}
                                />
                                ) : (
                                <LoginForm />
                                )
                                }
                        />
                        <Route 
                        path="/domino" 
                        element={
                            user ? (
                                <DominoGame 
                                key={`carrom-${dominoRematchKey}`}
                                onRematch={() => setDominoRematchKey(k => k + 1)}
                                />
                                ) : (
                                <LoginForm />
                                )
                                }
                        />
                </Routes>
            </div>

            {user && location.pathname === '/friends' && showCopyPopup && (
                <div className="copy-popup-overlay" onClick={() => setShowCopyPopup(false)}>
    <div className="copy-popup" onClick={(e) => e.stopPropagation()}>
        <div className="copy-popup-header">
            <h3 className="copy-popup-title">{t('copy_popup.title')}</h3> 
            <button className="copy-popup-close-btn" onClick={() => setShowCopyPopup(false)}>&times;</button>
        </div>
        <p className="manual-copy-link">{inviteLink}</p>
    </div>
</div>
            )}

 
{user && location.pathname !== '/rps' && location.pathname !== '/poker' && location.pathname !== '/domino' && location.pathname !== '/welcome' && location.pathname !== '/withdraw' && location.pathname !== '/deposit' && location.pathname !== '/affiliate-program' && location.pathname !== '/profile' && location.pathname !== '/depositStars' && location.pathname !== '/withdrawStars' && location.pathname !== '/Token-To-Usdt' && location.pathname !== '/played-games-history' && location.pathname !== '/transaction-history' && location.pathname !== '/carrom' && location.pathname !== '/backgammon' && location.pathname !== '/login' && location.pathname !== '/register' && location.pathname !== '/forgot-password' && location.pathname !== '/reset-password/:token' && location.pathname !== '/blot' && location.pathname !== '/deposit-withdraw-All' && !isGameLoading && (
  <footer className={`footer ${!isFooterVisible ? 'hidden-footer' : ''}`}>
    {/* GAMES */}
    <div className={`footer-item ${location.pathname === '/game' ? 'active' : ''}`} onClick={() => handleNavigation('/game')}>
        <img src={homeAssets.home} alt={t('footer.games')} className="footer-icon" />
        <span>{t('footer.games')}</span>
    </div>
    
    {/* TASKS */}
    <div className={`footer-item ${location.pathname === '/tasks' ? 'active' : ''}`} onClick={() => handleNavigation('/tasks')}>
        <img src={homeAssets.tasks} alt={t('footer.tasks')} className="footer-icon" />
        <span>{t('footer.tasks')}</span>
    </div>
    
    {/* FRIENDS */}
    <div className={`footer-item ${location.pathname === '/friends' ? 'active' : ''}`} onClick={() => handleNavigation('/friends')}>
        <img src={homeAssets.friends} alt={t('footer.friends')} className="footer-icon" />
        <span>{t('footer.friends')}</span>
    </div>
    
    {/* MORE */}
    <div className={`footer-item ${location.pathname === '/more' ? 'active' : ''}`} onClick={() => handleNavigation('/more')}>
        <img src={homeAssets.more} alt={t('footer.more')} className="footer-icon" />
        <span>{t('footer.more')}</span>
    </div>
</footer>
)}
        </div>
    );
};

export default App;

